import { useEffect, useRef } from "react";
import { drawMonoBitmap } from "../../receipt/receiptRender";
import type { MonoBitmap } from "../../receipt/bitmap";

/**
 * G-65 — the sticker, at the size it will actually be.
 *
 * TRUE SIZE, never scaled. A florist is matching this against a card they are
 * holding, so a preview shown at 70% is worse than none: it would answer the
 * one question they have ("will it fit?") with a confident lie. Where the strip
 * is longer than the frame the FRAME scrolls; the sticker does not shrink.
 */
export function NotePreview({ bitmap }: { bitmap: MonoBitmap }) {
  const host = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const mount = host.current;
    if (!mount) return;
    const shown = drawMonoBitmap(bitmap);
    shown.className = "sf-note-sticker";
    mount.replaceChildren(shown);
  }, [bitmap]);

  return <div className="sf-note-paper" ref={host} />;
}
